import { lazy } from "react";
// project import
import Loadable from "components/Loadable";

// ==============================|| ROUTES ITEMS - BELLINGCAT EVENTS ||============================== //

// render - BELLINGCAT EVENTS
const BellingcatEventsDefault = Loadable(
    lazy(() => import("pages/nostradamus/bellingcat-events/BellingcatEventsPage"))
);

const bellingcat_events = {
    path: "bellingcat-events",
    element: (
        <BellingcatEventsDefault />
    ),
};

export default bellingcat_events;
